export default [
  { label: 'KeyboardSettings', group: true },

  /******************* TODO: 实现保存MAGIC ****************
  { label: 'Keyboard settings (persistent)', width: 'label' },

  {
    name: 'Swap LCtl/Caps',
    code: 'MAGIC_SWAP_CONTROL_CAPSLOCK',
    title: 'Swap Left Control and Caps Lock',
    width: 1500
  },
  {
    name: 'Caps>LCtl',
    code: 'MAGIC_CAPSLOCK_TO_CONTROL',
    title: 'Treat Caps Lock as Left Control',
    width: 1500
  },
  {
    name: 'Swap LAlt/LGUI',
    code: 'MAGIC_SWAP_LALT_LGUI',
    title: 'Swap Left Alt and Left GUI',
    width: 1500
  },
  {
    name: 'Swap RAlt/RGUI',
    code: 'MAGIC_SWAP_RALT_RGUI',
    title: 'Swap Right Alt and Right GUI',
    width: 1500
  },
  {
    name: 'Disable GUI',
    code: 'MAGIC_NO_GUI',
    title: 'Disable the GUI keys (useful when gaming)',
    width: 1500
  },
  {
    name: 'Swap ` with Esc',
    code: 'MAGIC_SWAP_GRAVE_ESC',
    title: 'Swap ` and Escape',
    width: 1500
  },
  {
    name: 'Swap \\ with Bksp',
    code: 'MAGIC_SWAP_BACKSLASH_BACKSPACE',
    title: 'Swap Backslash and Backspace',
    width: 1500
  },
  {
    name: 'NKRO On',
    code: 'MAGIC_HOST_NKRO',
    title: 'Force N-Key Rollover (NKRO) on',
    width: 1500
  },
  {
    name: 'Swap Alt/GUI',
    code: 'MAGIC_SWAP_ALT_GUI',
    title: 'Swap Alt and GUI on both sides (for macOS)',
    width: 1500
  },
  {
    width: 0
  },
  {
    name: 'Rev LCtl/Caps',
    code: 'MAGIC_UNSWAP_CONTROL_CAPSLOCK',
    title: 'Unswap Left Control and Caps Lock',
    width: 1500
  },
  {
    name: 'Rev Caps>LCtl',
    code: 'MAGIC_UNCAPSLOCK_TO_CONTROL',
    title: 'Stop treating Caps Lock as Left Control',
    width: 1500
  },
  {
    name: 'Rev LAlt/LGUI',
    code: 'MAGIC_UNSWAP_LALT_LGUI',
    title: 'Unswap Left Alt and Left GUI',
    width: 1500
  },
  {
    name: 'Rev RAlt/RGUI',
    code: 'MAGIC_UNSWAP_RALT_RGUI',
    title: 'Unswap Right Alt and Right GUI',
    width: 1500
  },
  {
    name: 'Enable GUI',
    code: 'MAGIC_UNNO_GUI',
    title: 'Enable the GUI keys',
    width: 1500
  },
  {
    name: 'Rev ` with Esc',
    code: 'MAGIC_UNSWAP_GRAVE_ESC',
    title: 'Unswap ` and Escape',
    width: 1500
  },
  {
    name: 'Rev \\ with Bksp',
    code: 'MAGIC_UNSWAP_BACKSLASH_BACKSPACE',
    title: 'Unswap Backslash and Backspace',
    width: 1500
  },
  {
    name: 'NKRO Off',
    code: 'MAGIC_UNHOST_NKRO',
    title: 'Force N-Key Rollover (NKRO) off',
    width: 1500
  },
  {
    name: 'Rev Alt/GUI',
    code: 'MAGIC_UNSWAP_ALT_GUI',
    title: 'Unswap Alt and GUI on both sides (for macOS)',
    width: 1500
  },
  {
    name: 'Togg NKRO',
    code: 'MAGIC_TOGGLE_NKRO',
    title: 'Turn NKRO on or off',
    width: 1500
  },  // */

  {
    label: '背光',
    width: 'label'
  },

  {
    name: 'BL Toggle',
    code: 'BL_TOGG',
    title: '切换背光开或关'
  },
  {
    name: 'BL Cycle',
    code: 'BL_STEP',
    title: '循环设置背光亮度'
  },
  {
    name: 'BL On',
    code: 'BL_ON',
    title: '设置背光为最大亮度'
  },
  {
    name: 'BL Off',
    code: 'BL_OFF',
    title: '关闭背光'
  },
  {
    name: 'BL +',
    code: 'BL_INC',
    title: '增加背光亮度'
  },
  {
    name: 'BL -',
    code: 'BL_DEC',
    title: '减小背光亮度'
  },
  {
    name: 'BL Breath',
    code: 'BL_BRTG',
    title: '切换呼吸灯模式背光'
  },

  { label: 'RGB设置', width: 'label' },

  {
    name: 'RGB Toggle',
    code: 'RGB_TOG',
    title: '切换RGB开或关'
  },
  { name: 'RGB Mode +', code: 'RGB_MOD', title: '下一个RGB模式' },
  { name: 'RGB Mode -', code: 'RGB_RMOD', title: '上一个RGB模式' },
  { name: 'Hue +', code: 'RGB_HUI', title: '增加色调' },
  { name: 'Hue -', code: 'RGB_HUD', title: '减小色调' },
  { name: 'Sat +', code: 'RGB_SAI', title: '增加饱和度' },
  { name: 'Sat -', code: 'RGB_SAD', title: '减小饱和度' },
  { name: 'Bright +', code: 'RGB_VAI', title: '增加亮度' },
  { name: 'Bright -', code: 'RGB_VAD', title: '减小亮度' },
  { name: 'Effect +', code: 'RGB_SPI', title: '增加RGB效果速度' },
  { name: 'Effect -', code: 'RGB_SPD', title: '减小RGB效果速度' },
  { name: 'RGB Mode P', code: 'RGB_M_P', title: 'RGB模式: Plain' },
  { name: 'RGB Mode B', code: 'RGB_M_B', title: 'RGB模式: Breathe' },
  { name: 'RGB Mode R', code: 'RGB_M_R', title: 'RGB模式: Rainbow' },
  { name: 'RGB Mode SW', code: 'RGB_M_SW', title: 'RGB模式: Swirl' },
  { name: 'RGB Mode SN', code: 'RGB_M_SN', title: 'RGB模式: Snake' },
  { name: 'RGB Mode K', code: 'RGB_M_K', title: 'RGB模式: Knight Rider' },
  { name: 'RGB Mode X', code: 'RGB_M_X', title: 'RGB模式: Christmas' },
  { name: 'RGB Mode G', code: 'RGB_M_G', title: 'RGB模式: Gradient' },
  { name: 'RGB重置', code: 'RGB_RST', title: '重置RGB状态' },

  { label: '蓝牙', width: 'label' },

  { name: '设备1', code: 'SYS_BLE_ADV0', title: '配对设备1' },
  { name: '设备2', code: 'SYS_BLE_ADV1', title: '配对设备2' },
  { name: '设备3', code: 'SYS_BLE_ADV2', title: '配对设备3' },
  { name: '设备4', code: 'SYS_BLE_ADV3', title: '配对设备4' },
  { name: '设备5', code: 'SYS_BLE_ADV4', title: '配对设备5' },
  { width: 500 },
  { name: '删除设备1', code: 'SYS_BLE_DEL0', title: '删除配对设备1' },
  { name: '删除设备2', code: 'SYS_BLE_DEL1', title: '删除配对设备2' },
  { name: '删除设备3', code: 'SYS_BLE_DEL2', title: '删除配对设备3' },
  { name: '删除设备4', code: 'SYS_BLE_DEL3', title: '删除配对设备4' },
  { name: '删除设备5', code: 'SYS_BLE_DEL4', title: '删除配对设备5' },

  { width: 500 },

  { name: '断开连接', code: 'SYS_BLE_STOP_ADV', title: '关闭蓝牙广播，断开设备连接' },
  { name: '删除所有设备', code: 'SYS_BLE_DELBNDS', title: '删除所有配对设备' },
  { name: '蓝牙信息', code: 'SYS_BLE_INFO', title: '以自动打字的方式输出蓝牙连接信息' },

  { label: '键盘控制', width: 'label' },

  { name: '停用蓝牙', code: 'SYS_BLE_DIS', title: '禁用蓝牙（只是不向蓝牙连接的主机发送按键，而不是关闭蓝牙广播）' },
  { name: '启用蓝牙', code: 'SYS_BLE_EN', title: '启用蓝牙' },
  { name: '切换蓝牙', code: 'SYS_BLE_TOG', title: '切换蓝牙启用/禁用状态' },
  { width: 500 },
  { name: '停用USB', code: 'SYS_USB_DIS', title: '禁用USB（只是不向主机发送按键）' },
  { name: '启用USB', code: 'SYS_USB_EN', title: '启用USB' },
  { name: '切换USB', code: 'SYS_USB_TOG', title: '切换USB启用/禁用状态' },

  { width: 1000 },
  { name: 'DFU', code: 'SYS_ENT_DFU', title: '进入DFU刷机状态' },
  { name: '休眠', code: 'SYS_ENT_SLP', title: '进入休眠状态，按G键唤醒' },
  { name: '重启', code: 'SYS_REBOOT', title: '重启键盘' },
  { name: '电池电压', code: 'SYS_BATT_LV', title: '以自动打字的方式输出电池电压' }
];
